import { useBulkCheckpointUpload } from '../../hooks/BulkUpload/useBulkCheckpointUpload';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { UploadFileOutlined as UploadIcon } from '@mui/icons-material';
import BulkUploadModal from './BulkUploadModal';
import { GlobalButton } from '@/components';

interface BulkUploadButtonProps {
  useUploadHook?: typeof useBulkCheckpointUpload;
}

const BulkUploadButton = ({
  useUploadHook = useBulkCheckpointUpload,
}: BulkUploadButtonProps = {}) => {
  const {
    isOpen,
    openModal,
    closeModal,
    transition,
    setTransition,
    transitionOptions,
    isTransitionsLoading,
    rawText,
    setRawText,
    parseStats,
    unrecognizedLines,
    phase,
    processingStage,
    progress,
    failures,
    resultMessage,
    canSubmit,
    onConfirm,
    onCloseFailedResult,
  } = useUploadHook();

  return (
    <>
      <GlobalButton
        variant={GlobalButtonVariant.primaryButton}
        action={openModal}
        size='small'
      >
        <UploadIcon sx={{ mr: 1, fontSize: 18 }} />
        Carga masiva
      </GlobalButton>

      <BulkUploadModal
        isOpen={isOpen}
        onClose={closeModal}
        transition={transition}
        setTransition={setTransition}
        transitionOptions={transitionOptions}
        isTransitionsLoading={isTransitionsLoading}
        rawText={rawText}
        setRawText={setRawText}
        parseStats={parseStats}
        unrecognizedLines={unrecognizedLines}
        phase={phase}
        processingStage={processingStage}
        progress={progress}
        failures={failures}
        resultMessage={resultMessage}
        canSubmit={canSubmit}
        onConfirm={onConfirm}
        onCloseFailedResult={onCloseFailedResult}
      />
    </>
  );
};

export default BulkUploadButton;
